import { JOBS_PROFILE_PAGE, WAR_ROOM_POSTS_TAB_PAGE, WAR_ROOM_POSTS_TAB_TAB_PAGE } from './pages_generated';
import type { RouteConst } from './types/pages';

// this page is not under frontend application, so should be opened in a separate tab!
export const NEW_ACADEMY_PAGE = {
  name: 'academy',
  path: '/blog',
};

// expanded pages for pages with params
export const WAR_ROOM_POSTS_TAB_MYFEED_PAGE = {
  ...WAR_ROOM_POSTS_TAB_TAB_PAGE,
  params: { tab: 'my_feed' },
  path: '/war-room/posts/tab/my_feed',
};
export const WAR_ROOM_POSTS_TAB: RouteConst = {
  ...WAR_ROOM_POSTS_TAB_PAGE,
  path: '/war-room/posts/tab',
};

export const POSTS_PAGE: RouteConst = {
  path: '/war-room/posts',
  name: 'war-room-posts',
};

export const JOBS_CANDIDATE_PROFILE_PAGE: RouteConst = {
  path: '/jobs/profile',
  name: JOBS_PROFILE_PAGE.name,
};

/**
 * Pages for back compatibility, because they gone by redirects
 */
export const WAR_ROOM_PAGE = WAR_ROOM_POSTS_TAB_MYFEED_PAGE;

/**
 * Whenever you need link to portfolio you should use /p/ instead of /portfolio/
 * if you need to generate path or url to portfolio, please use helpers from here
 * frontend/utils/routes.ts
 */
export const PORTFOLIO_PAGE_PATH = '/p/';

export * from './pages_generated';
